import { z } from "zod";
import { assignmentSummarySchema } from "./auth.js";
import { isoDateSchema } from "./common.js";

export const assignmentsQuerySchema = z.object({
  employeeId: z.coerce.number().int().positive().optional(),
  from: isoDateSchema.optional(),
  to: isoDateSchema.optional(),
});
export type AssignmentsQuery = z.infer<typeof assignmentsQuerySchema>;

export const assignmentsResponseSchema = z.object({
  assignments: z.array(assignmentSummarySchema),
});
export type AssignmentsResponse = z.infer<typeof assignmentsResponseSchema>;
